<template>
  <b-modal
    ref="modal-abrircard"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione as informações de quadro, board e origem onde será gerado os
      cards
    </template>

    <section class="create__card__container pb-4">
      <div>
        <label class="form-label">Deseja executar agora ou programar?</label>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="execute-now"
            value="now"
            v-model="executeOption"
          />
          <label class="form-check-label" for="execute-now">
            Executar agora
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="schedule"
            value="schedule"
            v-model="executeOption"
          />
          <label class="form-check-label" for="schedule">
            Programar
          </label>
        </div>
        <div v-if="currentRecurrence">
          <label class="form-label">Status</label>
          <ToogleSwitch v-model="status"/>
        </div>
      </div>

      <ModalPeriodicidade
        v-if="executeOption === 'schedule'"
        ref="ModalPeriodicidade"
        :trigger-generate="generateCronTrigger"
        @cron-generated="handleCronGenerated"
        :cron-expression="currentRecurrence ? currentRecurrence.cronPeriodicidade : null"
      />

      <div>
        <SelectBoard @onSelect="loadColumns" :onlyActive="true" :selectedOption="createCard.boardId" />
      </div>
      <div>
        <SelectBoardColumn
          v-if="createCard.boardId"
          @onSelect="saveBoardAndColumn"
          :selectedOption="createCard.boardColumnId"
          :boardId="createCard.boardId"
          :key="createCard.boardId"
        />
      </div>
      <div>
        <SelectOrigem v-if="createCard.boardColumnId" @onSelect="saveOrigin" :selectedOption="createCard.originId" />
      </div>
    </section>

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="confirmSelection"
      icon="fas fa-check-circle"
      text="Salvar"
    />
  </b-modal>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'
import ModalPeriodicidade from '../component/ModalPeriodicidade.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

const AcaoListaInteligenteData = {
  boardColumnId: null,
  origemLeadId: null,
  acaoListaInteligente: 'OPEN_CARD',
  cronExpression: ''
}

export default {
  name: 'AbrirCardModal',
  components: {
    DefaultButton,
    SelectBoard,
    SelectBoardColumn,
    SelectOrigem,
    ModalPeriodicidade,
    ToogleSwitch
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null,
      createCard: {
        boardId: null,
        boardColumnId: null,
        originId: null
      },
      executeOption: 'now',
      generateCronTrigger: false,
      status: false
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.getRecorrencia()
        this.$refs['modal-abrircard'].show()
      }
    },
    hideModal () {
      this.$refs['modal-abrircard'].hide()
    },
    loadColumns (boardId) {
      this.createCard.boardId = boardId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.createCard.boardId = boardAndColumn[0]
      this.createCard.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.createCard.originId = origin
    },
    handleCronGenerated (cronExpression) {
      this.data.cronExpression = cronExpression
      const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'OPEN_CARD')

      if (foundRecurrence) {
        this.updateRecorrencia()
        this.$emit('reloadAcoes')
      } else {
        this.createRecorrencia()
        this.$emit('reloadAcoes')
      }
    },
    checkFieldsCreateCard () {
      if (this.createCard.boardId && this.createCard.boardColumnId && this.createCard.originId) return true
      else {
        toast.warning('Todos os campos devem estar preenchidos', 'Criar oportunidades')
        return false
      }
    },
    confirmSelection () {
      if (this.executeOption === 'schedule') {
        this.generateCronTrigger = true
        this.$nextTick(() => {
          this.data.boardColumnId = this.createCard.boardColumnId
          this.data.origemLeadId = this.createCard.originId
          this.generateCronTrigger = false
        })
      } else {
        this.finalizeCreateCard()
      }
    },
    finalizeCreateCard () {
      if (this.checkFieldsCreateCard() && (this.executeOption === 'now' || this.data.cronExpression)) {
        loading.push()
        this.data.boardColumnId = this.createCard.boardColumnId
        this.data.origemLeadId = this.createCard.originId

        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    },
    createRecorrencia () {
      const payload = {
        listaInteligenteId: this.acaoListaId,
        boardColumnId: this.data.boardColumnId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        origemLeadId: this.data.origemLeadId
      }

      RecorrenciaListaInteligenteRepository.Create(payload)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    getRecorrencia () {
      RecorrenciaListaInteligenteRepository.GetById(this.acaoListaId)
        .then((response) => {
          if (response.status === 200 && Array.isArray(response.data.content)) {
            this.recorrencia = response.data.content

            const foundRecurrence = this.recorrencia.find(item => item.acaoListaInteligente === 'OPEN_CARD')

            if (foundRecurrence) {
              this.onLoadAllBoards(foundRecurrence.boardColumnId)
              this.currentRecurrence = foundRecurrence
              this.executeOption = 'schedule'
              this.data.cronExpression = foundRecurrence.cronPeriodicidade
              this.createCard.originId = foundRecurrence.origemLeadId
              this.status = foundRecurrence.status
            } else {
              this.currentRecurrence = null
              this.executeOption = 'now'
              this.data.cronExpression = null
            }
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar recorrência:', error)
        })
    },
    updateRecorrencia () {
      if (!this.currentRecurrence) {
        return
      }

      const payload = {
        id: this.currentRecurrence.id,
        listaInteligenteId: this.acaoListaId,
        cronPeriodicidade: this.data.cronExpression,
        acaoListaInteligente: this.data.acaoListaInteligente,
        origemLeadId: this.data.origemLeadId,
        boardColumnId: this.data.boardColumnId,
        status: this.status
      }
      RecorrenciaListaInteligenteRepository.Update(payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
        })
        .catch((error) => {
          console.error('Erro ao atualizar recorrência:', error)
        })
    },
    onLoadAllBoards (id) {
      BoardColumnRepository.GetById(id)
        .then((response) => {
          this.boardColumns = response.data
          this.boardId = this.boardColumns.board.id
          this.createCard.boardId = this.boardId
          this.createCard.boardColumnId = id
        })
        .catch(this.onException)
    },
    toggleCreateUser () {
      this.status = !this.status
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/OpenCardModal.vue